import React, { Component } from 'react';
import Navbar from "./components/Navbar";
import Errors from "./components/Errors";
import dispatcher from "./dispatcher";
import './index.css';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mediaWidth: window.innerWidth
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({
      mediaWidth: window.innerWidth
    });
  }

  onClick() {
    dispatcher.dispatch({
      type: "BODY_CLICK",
    });
  }
  render() {
    const { mediaWidth } = this.state;
    const useCustomWidth = mediaWidth > 1400; // 自定义宽度的判断条件，这里假设媒体宽度小于 768px 时使用自定义宽度

    return (
      <div>
        <Navbar />
        <div className="container" style={useCustomWidth ? { width: '1300px' } : null} onClick={this.onClick}>
          <div className="row">
            <Errors />
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}


export default Layout;



// WEBPACK FOOTER //
// ./src/Layout.js